import styled, { css } from 'styled-components';

import media from '../../../utils/styling/media';

const ARROW_SIZE = 20;
const ARROW_BORDER_WIDTH = ARROW_SIZE * 0.65;
const ARROW_BORDER_HEIGHT = ARROW_SIZE * 0.60;

export const StyledArrow = styled.div`
  height: ${ARROW_SIZE}px;
  position: absolute;
  width: ${ARROW_SIZE}px;
  pointer-events: none;

  &::before {
    border-style: solid;
    content: '';
    display: block;
    height: 0;
    margin: auto;
    width: 0;    
  }

  &::after {
    border-style: solid;
    content: '';
    display: block;
    height: 0;
    margin: auto;
    position: absolute;
    width: 0;
  }
`;

export const StyledTooltip = styled.div<{
  visible: boolean;
  tooltipPadding: number;
  positioned: boolean;
  backgroundColor: string;
  color: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colors.gray4};
  box-shadow: 0 2px 4px ${({ theme }) => theme.colors.shadowGray1};
  color: ${({ color }) => color};
  display: flex;
  flex-direction: column;
  padding: ${({ tooltipPadding }) => tooltipPadding}px;
  transition: opacity 0.3s;
  z-index: 9999;    
  box-sizing: border-box;
  transition: none;
  word-break: break-word;

  ${({ positioned }) => !positioned && css`
    opacity: 0;
  `}

  ${media.xs`
    /* Width without the scrollbar & margins */
    max-width: calc((100vw - (100vw - 100%)) - 32px);
  `}

  ${media.sm`
    max-width: 400px;
    margin: 0;
  `}
  
  &[data-popper-placement*='bottom'] ${StyledArrow} {
    left: 0;
    margin-left: -2.5px;
    margin-top: -${ARROW_BORDER_HEIGHT - 1}px;
    top: 0;
  }

  &[data-popper-placement*='bottom'] ${StyledArrow}::before {
    border-color: transparent transparent ${({ theme }) => theme.colors.gray4} transparent;
    border-width: 0 ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px;
    position: absolute;
    top: -1px;
  }

  &[data-popper-placement*='bottom'] ${StyledArrow}::after {
    border-color: transparent transparent ${({ backgroundColor }) => backgroundColor} transparent;
    border-width: 0 ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px;
  }

  &[data-popper-placement*='top'] ${StyledArrow} {
    bottom: 0;
    left: 0;
    margin-left: -2.5px;
    margin-bottom: -${ARROW_SIZE - 1}px;
  }

  &[data-popper-placement*='top'] ${StyledArrow}::before {
    border-color: ${({ theme }) => theme.colors.gray4} transparent transparent transparent;
    border-width: ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px 0 ${ARROW_BORDER_WIDTH}px;
    position: absolute;
    top: 1px;
  }

  &[data-popper-placement*='top'] ${StyledArrow}::after {
    border-color: ${({ backgroundColor }) => backgroundColor} transparent transparent transparent;
    border-width: ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px 0 ${ARROW_BORDER_WIDTH}px;
  }

  &[data-popper-placement*='right'] ${StyledArrow} {
    left: 0;
    margin-top: -2px;
    margin-left: -${ARROW_SIZE - 3}px;
  }

  &[data-popper-placement*='right'] ${StyledArrow}::before {
    border-color: transparent ${({ theme }) => theme.colors.gray4} transparent transparent;
    border-width: ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px 0;
  }

  &[data-popper-placement*='right'] ${StyledArrow}::after {
    border-color: transparent ${({ backgroundColor }) => backgroundColor} transparent transparent;
    border-width: ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px ${ARROW_BORDER_WIDTH}px 0;
    left: 6px;
    top: 0;
  }

  &[data-popper-placement*='left'] ${StyledArrow} {
    margin-top: -2px;
    margin-right: -${ARROW_SIZE - 3}px;
    right: 0;
  }

  &[data-popper-placement*='left'] ${StyledArrow}::before {
    border-color: transparent transparent transparent ${({ theme }) => theme.colors.gray4};
    border-width: ${ARROW_BORDER_WIDTH}px 0 ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px;
  }

  &[data-popper-placement*='left'] ${StyledArrow}::after {
    border-color: transparent transparent transparent ${({ backgroundColor }) => backgroundColor};
    border-width: ${ARROW_BORDER_WIDTH}px 0 ${ARROW_BORDER_WIDTH}px ${ARROW_BORDER_HEIGHT}px;
    left: 3px;
    top: 0;
  }

  ${({ visible }) => !visible && css`
    display: none;
  `}
`;

export const StyledTooltipWrapper = styled.div<{
  position: string;
}>`
  width: 100vw;
  position: ${({ position }) => position};
`;
